export const i18n = {
    en: {
      login: 'Login',
      loginWithGoogle: 'Sign in with Google',
  loggingIn: 'Logging in...',
  close: 'Close',
  switchLanguage: 'Switch Language',
  user: 'User',
  username: 'User Name',
  // Username validation
  errorUsernameRequired: 'User name is required',
  errorUsernameMinLength: 'User name must be at least 3 characters',
      logout: 'Logout',
      welcome: 'Welcome',
      language: 'EN',
      home: 'Home',
      shop: 'Shop',
      aboutUs: 'About Us',
      ourStory: 'Our Story',
      ourProduct: 'Our Tea',
      contactUs: 'Contact Us',
      faq: 'FAQ',
      learn: 'Learn',
      teaKnowledge: 'Tea Knowledge',
      meditation: 'Meditation',
      life: 'Life',
      searchPlaceholder: 'Search...',
      searchButton: 'Search',
  shoppingCart: 'Shopping Cart',
  // Login modal
  email: 'Email',
  password: 'Password',
  rememberMe: 'Remember me',
  lostPassword: 'Lost your password?',
  loginWelcomeSubtitle: 'Welcome back! Please login to your account.',
  or: 'or',
  notMemberYet: 'Not a member yet?',
  registerNow: 'Register now',
  // LoginDropdown
  welcomeBack: 'Welcome Back',
  chooseLoginMethod: 'Choose Login Method',
  chooseLoginMethodSubtitle: 'Sign In',
  useEmailPassword: 'Use Email & Password',
  // Validation messages
  errorEmailRequired: 'Email is required',
  errorEmailInvalid: 'Please enter a valid email',
  errorPasswordRequired: 'Password is required',
  errorPasswordMinLength: 'Password must be at least 6 characters',
      // Shop page
      filterByPrice: 'Filter by price',
      minPrice: 'Min price',
      maxPrice: 'Max price',
      filter: 'Filter',
      categories: 'Categories',
      showingResults: 'Showing all {count} results',
      addToCart: 'Add to cart',
      selectOptions: 'Select options',
      giftSet: 'Gift Set',
      giftSets: 'Gift Sets',
      teaFormat: 'Tea Format',
      teaBags: 'Tea Bags',
      looseLeaf: 'Loose Leaf',
      blackTea: 'Black Tea',
      oolongTea: 'Oolong Tea',
      greenTea: 'Green Tea',
      noProductsInCart: 'No products in the cart.',
      // Core values section
      coreToHeart: 'Our core to your heart',
      originatedFromTaiwan: 'Originated from Taiwan',
      originatedFromTaiwanDesc: 'Our products are all produced and processed in Taiwan.',
      traceableSource: 'Traceable source',
      traceableSourceDesc: 'Our tea and candle products are straight from the farm and their producers.',
      relaxationAndWellness: 'Relaxation and Wellness',
      relaxationAndWellnessDesc: 'Relax yourself with our tea and candle to help you restore your wellness.',
      // Footer section
      ourProducts: 'Our Tea',
      privacyPolicy: 'Privacy Policy',
      refundReturns: 'Refund and Returns',
      profile: 'Profile',
      myAccount: 'My account',
      checkout: 'Checkout',
      followUs: 'Follow us',
      address: '',
      // Register
      register: 'Register',
      registerAnAccount: 'Create Account',
      displayName: 'Display Name',
      confirmPassword: 'Confirm Password',
      alreadyHaveAccount: 'Already have an account?',
      loginHere: 'Login here',
      errorDisplayNameRequired: 'Display name is required',
      errorPasswordsNotMatch: 'Passwords do not match',
      emailAlreadyExists: 'An account with this email already exists.',
      registrationSuccess: 'Account created successfully!',
      invalidCredentials: 'Invalid email or password.',
      // Profile page
      editProfile: 'Edit Profile',
      saveChanges: 'Save Changes',
      phoneNumber: 'Phone Number',
      authProvider: 'Login Method',
      authProviderGoogle: 'Google',
      authProviderEmail: 'Email & Password',
      authProviderBoth: 'Google + Email',
      memberSince: 'Member since',
      profileUpdated: 'Profile updated successfully.',
      // Account linking
      linkAccountTitle: 'Link Google Account',
      linkAccountMessage: 'An account with {email} already exists. Enter your password to link your Google account.',
      linkAccounts: 'Link Accounts',
      cancel: 'Cancel',
      linkingSuccess: 'Accounts linked successfully!',
      linkingFailed: 'Failed to link accounts. Please check your password.',
    },
    zh: {
      login: '登入',
      loginWithGoogle: '使用 Google 登入',
  loggingIn: '登入中...',
  close: '關閉',
  switchLanguage: '切換語言',
  user: '使用者',
  username: '使用者名稱',
  // Username validation
  errorUsernameRequired: '請輸入使用者名稱',
  errorUsernameMinLength: '使用者名稱至少 3 個字元',
      logout: '登出',
      welcome: '歡迎',
      language: '中',
      home: '首頁',
      shop: '商店',
      aboutUs: '關於我們',
      ourStory: '我們的故事',
      ourProduct: '我們的茶',
      contactUs: '聯絡我們',
      faq: '常見問題',
      learn: '學習',
      teaKnowledge: '茶知識',
      meditation: '冥想',
      life: '生活',
      searchPlaceholder: '搜尋...',
      searchButton: '搜尋',
  shoppingCart: '購物車',
  // Login modal
  email: '電子郵件',
  password: '密碼',
  rememberMe: '記住我',
  lostPassword: '忘記密碼？',
  loginWelcomeSubtitle: '歡迎回來！請登入您的帳號。',
  or: '或',
  notMemberYet: '還不是會員？',
  registerNow: '立即註冊',
  // LoginDropdown
  welcomeBack: '歡迎回來',
  chooseLoginMethod: '選擇登入方式',
  chooseLoginMethodSubtitle: 'Sign In',
  useEmailPassword: '使用信箱密碼登入',
  // Validation messages
  errorEmailRequired: '請輸入電子郵件',
  errorEmailInvalid: '請輸入有效的電子郵件',
  errorPasswordRequired: '請輸入密碼',
  errorPasswordMinLength: '密碼至少需要6個字符',
      // Shop page
      filterByPrice: '價格篩選',
      minPrice: '最低價格',
      maxPrice: '最高價格',
      filter: '篩選',
      categories: '分類',
      showingResults: '顯示全部 {count} 項結果',
      addToCart: '加入購物車',
      selectOptions: '選擇選項',
      giftSet: '禮盒',
      giftSets: '禮盒組',
      teaFormat: '茶葉格式',
      teaBags: '茶包',
      looseLeaf: '散茶',
      blackTea: '紅茶',
      oolongTea: '烏龍茶',
      greenTea: '綠茶',
      noProductsInCart: '購物車中沒有商品',
      // Core values section
      coreToHeart: '我們的核心到您的心',
      originatedFromTaiwan: '來自台灣',
      originatedFromTaiwanDesc: '我們的產品全部在台灣生產和加工。',
      traceableSource: '可追蹤來源',
      traceableSourceDesc: '我們的茶葉和蠟燭產品直接來自農場和生產者。',
      relaxationAndWellness: '放鬆與健康',
      relaxationAndWellnessDesc: '用我們的茶和蠟燭放鬆自己，幫助您恢復健康。',
      // Footer section
      ourProducts: '我們的茶',
      privacyPolicy: '隱私政策',
      refundReturns: '退款與退貨',
      profile: '個人檔案',
      myAccount: '我的帳戶',
      checkout: '結帳',
      followUs: '追蹤我們',
      address: '',
      // Register
      register: '註冊',
      registerAnAccount: '建立帳號',
      displayName: '顯示名稱',
      confirmPassword: '確認密碼',
      alreadyHaveAccount: '已有帳號？',
      loginHere: '立即登入',
      errorDisplayNameRequired: '請輸入顯示名稱',
      errorPasswordsNotMatch: '兩次密碼不一致',
      emailAlreadyExists: '此電子郵件已有帳號。',
      registrationSuccess: '帳號建立成功！',
      invalidCredentials: '電子郵件或密碼不正確。',
      // Profile page
      editProfile: '編輯個人資料',
      saveChanges: '儲存變更',
      phoneNumber: '手機號碼',
      authProvider: '登入方式',
      authProviderGoogle: 'Google',
      authProviderEmail: '電子郵件與密碼',
      authProviderBoth: 'Google + 電子郵件',
      memberSince: '加入時間',
      profileUpdated: '個人資料更新成功。',
      // Account linking
      linkAccountTitle: '連結 Google 帳號',
      linkAccountMessage: '此電子郵件 {email} 已有帳號，請輸入密碼以連結您的 Google 帳號。',
      linkAccounts: '連結帳號',
      cancel: '取消',
      linkingSuccess: '帳號連結成功！',
      linkingFailed: '連結失敗，請確認密碼是否正確。',
    }
  }
  
